import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        locale: '',
        token: '',
        user: null,
        stripeAuthOrganization: null
    },
    mutations: {
        storeLocale(state, value) {
            state.locale = value
        },
        storeToken(state, value) {
            state.token = value
        },
        storeUser(state, value) {
            state.user = value
        },
        mergeUser(state, value) {
            Object.assign(state, value);
        },
        storeStripeAuthOrganization(state, value) {
            state.stripeAuthOrganization = value
        }
    },
    plugins: [createPersistedState()]
})

export default store